import api from '@/common/api/cobrandApiClient'

export const FETCH_OFFERS_START = 'FETCH_OFFERS_START'
export const FETCH_GAME_OFFERS_SUCCESS = 'FETCH_GAME_OFFERS_SUCCESS'
export const FETCH_LAST_OFFERS_SUCCESS = 'FETCH_LAST_OFFERS_SUCCESS'
export const FETCH_OFFERS_ERROR = 'FETCH_OFFERS_ERROR'

/** Default state for Offers module */
export const defaultState = {
  gameOffers: [],
  lastOffers: [],
  meta: {},
  loading: false,
  errors: null
}

/** Offers State mutations */
export const mutations = {
  [FETCH_OFFERS_START] (state) {
    state.loading = true
  },

  [FETCH_GAME_OFFERS_SUCCESS] (state, { offers, meta }) {
    state.gameOffers = offers
    state.meta = meta
    state.loading = false
  },

  [FETCH_LAST_OFFERS_SUCCESS] (state, { offers }) {
    state.lastOffers = offers
    state.loading = false
  },

  [FETCH_OFFERS_ERROR] (state, errors) {
    state.loading = false
    state.errors = errors
  }
}

/**
 * Fetch Offers by game
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {String} payload.game
 */
export async function fetchOffersByGame ({ commit, rootState }, { game }) {
  commit(FETCH_OFFERS_START)
  try {
    const queryParams = {
      filter: {
        games: [game],
        country_codes: [rootState.country]
      }
    }
    const result = await api.fetchOffers(queryParams)

    commit(FETCH_GAME_OFFERS_SUCCESS, result)
  } catch (error) {
    commit(FETCH_OFFERS_ERROR, error)
    throw error
  }
}

export async function fetchLastOffers ({ commit, rootState }) {
  commit(FETCH_OFFERS_START)
  try {
    const queryParams = {
      page: { limit: 3 },
      filter: { country_codes: [rootState.country] }
    }
    const result = await api.fetchOffers(queryParams)

    commit(FETCH_LAST_OFFERS_SUCCESS, { ...result })
  } catch (error) {
    commit(FETCH_OFFERS_ERROR, error)
    throw error
  }
}

/**
 * Offers State Vuex module
 */
export default {
  namespaced: true,
  state: () => defaultState,
  mutations,
  actions: { fetchLastOffers, fetchOffersByGame }
}
